import type { ActivityContentObjectDetail, ActivityContentObjectList } from 'models';
import { useMutation } from 'query';
import { deleteActivity } from '../../services';
import { getContentObjectId } from '../../utils';
import { useContentObjectCache } from '../cache';

type DeleteActivityContentObject = { contentObject: ActivityContentObjectDetail | ActivityContentObjectList };

export const useDeleteActivityContentObjectMutation = () => {
  const cache = useContentObjectCache();

  return useMutation<DeleteActivityContentObject, DeleteActivityContentObject>({
    async mutationFn(object) {
      await deleteActivity({ routeParams: { id: getContentObjectId(object.contentObject) } });

      return object;
    },
    onSuccess(_data, { contentObject }) {
      cache.remove(contentObject);
    },
  });
};
